import Pikaday from 'pikaday';
import { formatDateYmd } from '../defs';

export default function initArticles() {
    const toolsEl = document.getElementById('artclTools');
    toolsEl && initTools(toolsEl);
}

/**
 *
 * @param {HTMLElement} el
 */
function initTools(el) {
    const formEl = document.getElementById('artclTools-form');
    // const textInputEl = document.getElementById('artclTools-text')
    const dtFromEl = document.getElementById('artclTools-dtFrom');
    const dtToEl = document.getElementById('artclTools-dtTo');
    const resetBtnEl = document.getElementById('artclTools-resetBtn');

    const pickerArgs = {
        firstDay: 1,
        i18n: {
            previousMonth: 'Föregående månad',
            nextMonth: 'Nästa månad',
            months: [
                'Januari',
                'Februari',
                'Mars',
                'April',
                'Maj',
                'Juni',
                'Juli',
                'Augusti',
                'September',
                'Oktober',
                'November',
                'December',
            ],
            weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Önsdag', 'Tordag', 'Fredag', 'Lördag'],
            weekdaysShort: ['Sön', 'Mån', 'Tis', 'Öns', 'Tor', 'Fre', 'Lör'],
        },
        onSelect(instance) {
            formEl.submit();
        },
        format: 'YYYY-MM-DD',
        yearRange: [2012, (new Date()).getFullYear()],
        showWeekNumber: true,
        toString(date, format) {
            return formatDateYmd(date);
        },
        parse(dateString, format) {
            const parts = dateString.split('-');
            const [year, month, day] = [parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])];
            return new Date(year, month, day);
        },
    };

    const dtFrom = new Pikaday({
        field: dtFromEl,
        ...pickerArgs,
    });
    const dtTo = new Pikaday({
        field: dtToEl,
        ...pickerArgs,
    });

    if (dtFromEl.value) {
        const initialDtFrom = new Date(Date.parse(dtFromEl.value + 'T00:00:00'));
        dtFrom.gotoDate(initialDtFrom);
    }

    if (dtToEl.value) {
        const initialDtTo = new Date(Date.parse(dtToEl.value + 'T00:00:00'));
        dtTo.gotoDate(initialDtTo);
    }

    ;[dtFromEl, dtToEl].forEach(el => {
        el.addEventListener('keypress', event => {
            if (event.key === 'Enter') {
                formEl.submit();
            }
        });
    });
    resetBtnEl.addEventListener('click', () => {
        dtFromEl.value = '';
        dtToEl.value = '';
        formEl.appendChild(Object.assign(document.createElement('input'), {
            type: 'hidden',
            value: 1,
            name: 'paged',
        }));
        formEl.submit();
    });

    checkResetBtnState();

    function checkResetBtnState() {
        if (dtFrom.getDate() || dtTo.getDate()) {
            resetBtnEl.removeAttribute('disabled');
        } else {
            resetBtnEl.setAttribute('disabled', 'disabled');
        }
    }
}
